import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const WhyUs = lazy(() => import('../pages/why-us/page'));
const Courses = lazy(() => import('../pages/courses/page'));
const ScienceCurriculum = lazy(() => import('../pages/science-curriculum/page'));
const MathCurriculum = lazy(() => import('../pages/math-curriculum/page'));
const Reviews = lazy(() => import('../pages/reviews/page'));
const Pricing = lazy(() => import('../pages/pricing/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/why-us',
    element: <WhyUs />,
  },
  {
    path: '/courses',
    element: <Courses />,
  },
  {
    path: '/science-curriculum',
    element: <ScienceCurriculum />,
  },
  {
    path: '/math-curriculum',
    element: <MathCurriculum />,
  },
  {
    path: '/reviews',
    element: <Reviews />,
  },
  {
    path: '/pricing',
    element: <Pricing />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;